/**
 * ACH Helper Functions
 * These functions provide centralized logic for ACH-related display decisions
 * and can be accessed from anywhere in the application.
 */

/**
 * Check if Dwolla is properly configured for the current client
 * @returns {boolean} True if Dwolla is configured with valid environment
 */
const isDwollaConfigured = () => {
    const dwollaEnv = clientData?.ach_env;
    return dwollaEnv === 'dwolla_sandbox' || dwollaEnv === 'dwolla_prod';
};

/**
 * Check if ACH tab should be shown based on client configuration
 * @returns {boolean} True if ACH tab should be displayed
 */
const showAchTab = () => {
    return clientData.tabs?.show_ach && isDwollaConfigured();
};

// Export functions to global scope for backward compatibility
if (typeof window !== 'undefined') {
    window.isDwollaConfigured = isDwollaConfigured;
    window.showAchTab = showAchTab;
}

// Export for module systems (if applicable)
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        isDwollaConfigured,
        showAchTab
    };
}
